import * as React from 'react'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as st from './ageVerification.module.scss'
import { ConditionalMessage } from '../../utils/conditionalText'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as cn from 'classnames'

export interface IAgeVerificationProps {
  message?: WpsRuntime.atv.wps.Message,
}

export const AgeVerification = ({ message}: IAgeVerificationProps) => {
  if (!message) {
    return null
  }

  return (
    <div className={cn('age-verification-message', utilityClasses.fullWidth)}>
      <ConditionalMessage message={message} className={st.message} />
    </div>
  )
}
